import { Injectable } from "@angular/core";
import { AppContextConfigService, CoreHttpClient, MarketConfigService } from "@obg/ngx.core";
import { CookieService } from "@obg/ngx.global";
import { addMinutes } from "date-fns";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

import { DepositLimitCalculatorConfigService } from "./deposit-limit-calculator-config";
import { DEPOSIT_LIMIT_CALCULATOR_PREDICTIONS_KEY } from "./deposit-limit-calculator.const";
import { DepositLimitCalculatorPredictionsResponse } from "./deposit-limit-calculator.model";

@Injectable({
	providedIn: "root",
})
export class DepositLimitCalculatorService {
	cachedValue: DepositLimitCalculatorPredictionsResponse | undefined;

	constructor(
		private httpClient: CoreHttpClient,
		private depositLimitCalculatorConfigService: DepositLimitCalculatorConfigService,
		private cookieService: CookieService,
		private appContextConfig: AppContextConfigService,
		private marketConfig: MarketConfigService
	) {}

	deletePredictions(): void {
		this.cookieService.delete(DEPOSIT_LIMIT_CALCULATOR_PREDICTIONS_KEY);
	}

	fetchPredictions(sessionToken = ""): Observable<DepositLimitCalculatorPredictionsResponse> {
		this.cachedValue = this.cookieService.getJson(DEPOSIT_LIMIT_CALCULATOR_PREDICTIONS_KEY);

		return this.cachedValue
			? of(this.cachedValue)
			: this.httpClient
					.get<DepositLimitCalculatorPredictionsResponse>({
						url: this.depositLimitCalculatorConfigService.getDepositLimitCalculatorEndpoint(),
						headers: {
							brandId: this.appContextConfig.getApiToken(),
							marketCode: this.marketConfig.getLanguageCode(),
							sessionToken,
						},
					})
					.pipe(
						map((value) => {
							const expiryDate = addMinutes(new Date(), 1);
							const name = DEPOSIT_LIMIT_CALCULATOR_PREDICTIONS_KEY;
							this.cookieService.setJson({
								expiryDate,
								name,
								value,
							});
							return value;
						})
					);
	}
}
